import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";

import { AppNavComponent } from "./app-nav";
import { SiteNavModule } from "./site-nav";

@NgModule({
  imports: [CommonModule, RouterModule, BrowserAnimationsModule],
  declarations: [AppNavComponent],
  exports: [AppNavComponent, SiteNavModule]
})
export class NavigationModule {}
